export const animeList = [
  {
    id: "huaji-jixing",
    title: "花季纪行",
    titleJp: "はなの季節",
    category: "youth-heal",
    year: 2019,
    season: "春",
    episodes: 12,
    status: "已完结",
    studio: "东风动画",
    director: "林悦",
    tags: ["青春", "校园", "治愈", "日常"],
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20teenage%20girl%20standing%20under%20blooming%20cherry%20blossom%20trees%20in%20spring%2C%20soft%20pink%20petals%20drifting%20in%20the%20air%2C%20warm%20golden%20sunlight%2C%20gentle%20pastel%20color%20palette%2C%20nostalgic%20healing%20mood%2C%20clean%20simple%20sky%20background%2C%20vertical%20poster%20composition&width=600&height=800&seq=anime-cover-01&orientation=portrait",
    summary:
      "转学而来的少女与旧校舍、旧朋友之间的重新认识。整部作品把“告别”讲得很轻，却在细枝末节里反复出现。",
    synopsis: [
      "《花季纪行》讲的是一段很短的春天。女主角因为家庭原因转学到祖母生活过的小镇，被安排住进一间靠近旧校舍的房子。她在新的班级里并不显眼，却因为一次值日意外，和几个性格完全不同的同学产生了交集。",
      "故事没有明显的反派，冲突几乎都来自“要不要说出口”。有人害怕被拒绝，有人担心自己的梦想太普通，有人只是习惯了把情绪藏起来。动画用大量的空镜和季节细节去承接这些情绪：一场雨、一块写满字的黑板、放学后没关的教室灯。",
      "到了结尾，作品并没有给出大团圆的答案，而是让每个人带着一点遗憾继续往前走。这种“没说完”的处理，恰恰是它最打动人的地方。",
    ],
    highlights: [
      "用四季推移串联起十二集的情绪节奏，春天开花、夏天雷雨、秋天落叶各有对应。",
      "配乐克制，主题旋律只在两处完整出现，一次在开头，一次在最后一集。",
      "美术上刻意降低饱和度，把暖色留给角色真正放松的时刻。",
    ],
    characters: [
      { name: "苏念", role: "主角", desc: "转学生，习惯先观察再开口，擅长做手工。" },
      { name: "陈屿", role: "同班同学", desc: "话不多，却总在关键时候出现的那种人。" },
      { name: "林老师", role: "班主任", desc: "看似随意，其实记得每个学生的去向。" },
    ],
  },
  {
    id: "xinghai-lieche",
    title: "星海列车",
    titleJp: "星海列車",
    category: "scifi-mecha",
    year: 2021,
    season: "秋",
    episodes: 24,
    status: "已完结",
    studio: "远航线工作室",
    director: "高桥诚",
    tags: ["科幻", "冒险", "星际", "群像"],
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20sleek%20futuristic%20train%20traveling%20through%20a%20glowing%20starfield%20and%20colorful%20nebula%2C%20deep%20teal%20and%20warm%20gold%20accents%2C%20cosmic%20dust%20trails%2C%20a%20lone%20passenger%20silhouette%20at%20the%20window%2C%20cinematic%20sci-fi%20atmosphere%2C%20clean%20simple%20background%2C%20vertical%20poster%20composition&width=600&height=800&seq=anime-cover-02&orientation=portrait",
    summary:
      "一列永远在星际间穿行的列车，载着各自带着理由上车的乘客。科幻外壳下，是一部关于“回家”的群像剧。",
    synopsis: [
      "《星海列车》设定在一个人类已经散布于多个恒星系的未来。列车“长庚号”沿着一条几乎被废弃的航线巡航，负责把滞留在各站的旅客送回故乡。它没有固定终点，也没有正式的时刻表。",
      "每一站都像一集独立的小故事：等待多年的老人、临时顶班的机械师、想找回哥哥遗物的少年。列车组用有限的技术条件去解决这些看似琐碎的请求，过程中逐渐揭开长庚号本身被设计出来的真正原因。",
      "作品最出色的是对“尺度”的把握——它不急着解释宇宙，而是把宏大设定收束到一个个具体的相遇里。二十四集看下来，你会记得的不是飞船参数，而是那些下车时回头挥手的人。",
    ],
    highlights: [
      "单元剧结构与主线伏笔交替推进，每一集都能独立成立。",
      "机械设计偏向“可以维修”的实用风格，强调零件与人力而非炫技。",
      "长庚号本身就是一个角色，车厢布置随剧情悄然改变。",
    ],
    characters: [
      { name: "穆青", role: "列车长", desc: "经验老到，坚持为每位旅客留一张返回的车票。" },
      { name: "阿澈", role: "机械师", desc: "自学成才，能把报废零件拼回原样。" },
      { name: "白榆", role: "导航员", desc: "记得航线图上每一颗被标注过的星。" },
    ],
  },
  {
    id: "jian-yu-chenguang",
    title: "剑与晨光",
    titleJp: "剣と曙",
    category: "hot-blood",
    year: 2020,
    season: "夏",
    episodes: 12,
    status: "已完结",
    studio: "破晓美术",
    director: "周砚",
    tags: ["冒险", "成长", "剑术", "热血"],
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20young%20swordsman%20holding%20a%20longsword%20at%20dawn%20on%20a%20mountain%20ridge%2C%20golden%20morning%20light%20breaking%20through%20mist%2C%20flowing%20cape%2C%20dramatic%20heroic%20pose%2C%20warm%20amber%20and%20soft%20grey%20palette%2C%20simple%20sky%20background%2C%20vertical%20poster%20composition&width=600&height=800&seq=anime-cover-03&orientation=portrait",
    summary:
      "一个被逐出师门的年轻人，用最笨的方式重新证明自己。它讲“坚持”但不神化天赋。",
    synopsis: [
      "主角陆舟自幼在剑馆长大，却因为一次比试中的失误被逐出师门。他没有主角光环式的觉醒，只能带着一把旧剑和一堆没解开的疑问，沿着山路往北走。",
      "旅途中他遇到形形色色的人：教他辨风的猎人、输过很多次的对手、以及一位从不轻易出剑的旅伴。作品把重点放在“练”上——重复、受伤、复盘，慢慢积累出一点点改变。",
      "全片的打斗并不追求数量，每一场都有明确的动机与代价。最后的对决没有华丽特效，只有一次判断与一次选择。",
    ],
    highlights: [
      "动作作画讲究发力逻辑，每一场战斗都能看出双方的心态变化。",
      "晨光是全片的视觉母题，重要场景几乎都发生在日出前后。",
      "把“失败”当作叙事资源，而不是必须先消除的障碍。",
    ],
    characters: [
      { name: "陆舟", role: "主角", desc: "被逐出师门的年轻剑士，倔强且善于复盘。" },
      { name: "风见奶奶", role: "向导", desc: "隐居山中的猎人，教会他如何读懂环境。" },
      { name: "沈砚", role: "旅伴", desc: "寡言的同行者，只在必要的时候出剑。" },
    ],
  },
  {
    id: "shenye-lamian",
    title: "深夜拉面馆",
    titleJp: "深夜ラーメン",
    category: "romance-daily",
    year: 2018,
    season: "冬",
    episodes: 12,
    status: "已完结",
    studio: "小满制作组",
    director: "田边澪",
    tags: ["美食", "日常", "治愈", "温情"],
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20cozy%20small%20ramen%20shop%20at%20night%20with%20warm%20lantern%20glow%2C%20a%20steaming%20bowl%20of%20noodles%20on%20the%20counter%2C%20soft%20rain%20outside%20the%20window%2C%20inviting%20cozy%20daily%20life%20mood%2C%20warm%20orange%20and%20cream%20palette%2C%20simple%20background%2C%20vertical%20poster%20composition&width=600&height=800&seq=anime-cover-04&orientation=portrait",
    summary:
      "凌晨才开始营业的小面馆，客人各有心事，老板只管把面煮好。每一碗背后是一段没被说出口的日常。",
    synopsis: [
      "《深夜拉面馆》是一部很安静的日常番。店面不大，菜单只有几样，老板也几乎不主动提问。每晚来的客人不一样，点的面不一样，聊到的烦恼也不一样。",
      "作品几乎不给老板加旁白，所有信息都藏在客人的对话和老板加入的那一两个小配料里。有人失恋、有人加班、有人只是走错了路，但坐下来吃碗热面的那一刻，情绪都被暂时安放。",
      "十二集结束，你会觉得像连续去了十二次同一家店。它不解决任何人的大问题，却让每个普通夜晚变得值得记录。",
    ],
    highlights: [
      "食物作画细致，蒸汽、汤色与面条弹性的表现非常到位。",
      "采用近乎真实的时间流逝节奏，适合一个人慢慢看。",
      "每集结尾的“今日菜单”小卡片是固定惊喜。",
    ],
    characters: [
      { name: "老周", role: "店主", desc: "话少手艺稳，记得每位常客的口味。" },
      { name: "小袁", role: "兼职店员", desc: "大学生，负责打下手和陪聊。" },
      { name: "常客们", role: "群像", desc: "每个深夜推门进来的人，都带来一个小故事。" },
    ],
  },
  {
    id: "yueding-zhonglou",
    title: "约定的钟楼",
    titleJp: "約束の鐘楼",
    category: "romance-daily",
    year: 2022,
    season: "春",
    episodes: 12,
    status: "已完结",
    studio: "晚照动画",
    director: "顾平成",
    tags: ["恋爱", "剧情", "青春", "治愈"],
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20boy%20and%20a%20girl%20standing%20in%20front%20of%20an%20old%20clock%20tower%20at%20sunset%2C%20long%20shadows%2C%20warm%20rose%20and%20gold%20evening%20sky%2C%20romantic%20gentle%20atmosphere%2C%20soft%20focus%20background%2C%20delicate%20line%20art%2C%20vertical%20poster%20composition&width=600&height=800&seq=anime-cover-05&orientation=portrait",
    summary:
      "一座每天都会慢一分钟的钟楼，藏着两个人跨越三年的约定。温柔但不甜腻，克制是它最动人的地方。",
    synopsis: [
      "小镇的钟楼有一个奇怪的习惯：每天傍晚都会慢一分钟。女主角许微在搬家前夜和重逢的旧友立下一个约定，而这个约定恰好和钟楼的误差有关。",
      "故事在现在与回忆之间来回切换，用同一处场景的两个时间点做对照。你会发现，许多当时没听懂的对话，都是在多年后才显出意义。",
      "作品没有刻意的误会桥段，冲突来自两个人都太在意对方。结尾落在钟楼修好的那一天，慢了一分钟的习惯消失，约定却留了下来。",
    ],
    highlights: [
      "双时间线结构清晰，用钟声作为转场提示。",
      "台词密度低，大量情绪交给表情与时停镜头。",
      "色调随回忆变暖、随现实转冷，视觉区分明显。",
    ],
    characters: [
      { name: "许微", role: "主角", desc: "即将离开小镇的女孩，习惯把话留到最后。" },
      { name: "程屿", role: "主角", desc: "守着钟楼的少年，固执地认为约定不必说出口。" },
      { name: "钟表匠", role: "长辈", desc: "修了一辈子钟，却总说不必分秒不差。" },
    ],
  },
  {
    id: "longwen-jijia",
    title: "龙纹机甲",
    titleJp: "龍紋機甲",
    category: "scifi-mecha",
    year: 2023,
    season: "秋",
    episodes: 24,
    status: "连载中",
    studio: "铁鳞工作室",
    director: "韩屹",
    tags: ["机战", "科幻", "热血", "群像"],
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20giant%20mecha%20robot%20with%20glowing%20dragon-shaped%20energy%20lines%20on%20its%20armor%2C%20standing%20in%20a%20ruined%20futuristic%20city%2C%20dramatic%20lighting%2C%20emerald%20green%20and%20amber%20accents%2C%20metallic%20textures%2C%20simple%20dark%20background%2C%20vertical%20poster%20composition&width=600&height=800&seq=anime-cover-06&orientation=portrait",
    summary:
      "以“龙纹”为动力核心的机甲部队，在废土城市中求生存。机战之外，更在意体系与人的关系。",
    synopsis: [
      "《龙纹机甲》设定在一次资源枯竭后的世界。机甲的动力来自刻在装甲上的“龙纹回路”，每一道纹路都对应一名驾驶员的生命节律。这让机体强大，也让它危险。",
      "主角团队并非精英中的精英，而是被临时拼凑起来的维修班。他们既要面对外部的威胁，也要处理内部对“谁有权决定出击”的分歧。",
      "作品的动作演出扎实，机体的重量感与磨损感非常真实。更难得的是，它愿意花时间讨论规则本身，而不是只把冲突推向战斗。",
    ],
    highlights: [
      "机设强调工业感，装甲上可见维修痕迹与补丁。",
      "战斗与会议交替，用“决策过程”推动剧情。",
      "龙纹回路是可被理解的设定，规则前后一致。",
    ],
    characters: [
      { name: "秦野", role: "驾驶员", desc: "维修班出身，擅长在极限下判断。" },
      { name: "苏黎", role: "战术官", desc: "坚持用数据说话，却常为队友破例。" },
      { name: "老姚", role: "班长", desc: "修了半辈子机甲，最懂机器的脾气。" },
    ],
  },
  {
    id: "zhishang-wangguo",
    title: "纸上王国",
    titleJp: "紙の王国",
    category: "mystery-fantasy",
    year: 2017,
    season: "夏",
    episodes: 12,
    status: "已完结",
    studio: "折页工房",
    director: "白川遥",
    tags: ["奇幻", "冒险", "解谜", "治愈"],
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20magical%20kingdom%20made%20of%20folded%20paper%20and%20origami%20castles%2C%20a%20small%20traveler%20walking%20along%20a%20paper%20path%2C%20soft%20cream%20and%20warm%20brown%20palette%2C%20whimsical%20fantasy%20mood%2C%20gentle%20light%2C%20simple%20background%2C%20vertical%20poster%20composition&width=600&height=800&seq=anime-cover-07&orientation=portrait",
    summary:
      "主角走进一本没写完的书，王国由折纸构成，规则由阅读的人决定。想象力是它最大的武器。",
    synopsis: [
      "少女阿禾在旧书摊得到一本缺了结尾的童话。她随手写下自己的名字，竟被拉进书中的世界——一个由折纸与墨线构成的王国。",
      "这里的物理规则白天正常，夜晚会随“读者”的心情变化。要走出王国，她必须补全故事，但每一次改写都会牵动其中人物的命运。",
      "作品把“创作”本身作为主题：你以为自己在写故事，其实故事也在写你。结尾的留白让很多观众反复回想。",
    ],
    highlights: [
      "全片美术以纸张与墨线为基底，风格辨识度极高。",
      "每一集的结构都像一则短篇寓言，可独立欣赏。",
      "设置大量视觉伏笔，二刷能发现不少细节。",
    ],
    characters: [
      { name: "阿禾", role: "主角", desc: "爱读书的少女，习惯用故事解释世界。" },
      { name: "墨先生", role: "引路人", desc: "王国的守则化身，语气永远像在念旁白。" },
      { name: "折鹤", role: "伙伴", desc: "会飞的纸鹤，负责把主角带离危险。" },
    ],
  },
  {
    id: "xiari-huisheng",
    title: "夏日回声",
    titleJp: "夏の残響",
    category: "mystery-fantasy",
    year: 2024,
    season: "夏",
    episodes: 12,
    status: "连载中",
    studio: "潮汐映画",
    director: "南云卓",
    tags: ["悬疑", "青春", "海边", "群像"],
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20quiet%20seaside%20town%20in%20midsummer%2C%20a%20girl%20listening%20to%20an%20old%20radio%20on%20a%20wooden%20pier%2C%20deep%20sky%20and%20warm%20sunset%20gradient%2C%20mysterious%20nostalgic%20mood%2C%20soft%20haze%2C%20simple%20background%2C%20vertical%20poster%20composition&width=600&height=800&seq=anime-cover-08&orientation=portrait",
    summary:
      "暑假回到海边小镇的少年，在一台旧收音机里听到了不属于这个夏天的声音。悬疑氛围与青春气息并重。",
    synopsis: [
      "《夏日回声》从一个很平常的暑假开始。主角回到外婆居住的海边小镇，帮家里整理旧屋，无意中修好了一台老式收音机。",
      "收音机每晚固定时间会收到一段模糊的广播，内容似乎指向镇上多年前的一桩旧事。主角和几位童年玩伴决定顺着线索查下去，越接近真相，越发现每个人都记得不同的版本。",
      "作品用盛夏的光与海作为背景，把悬疑铺得很慢。它真正想追问的，是“记忆到底能不能被信任”。",
    ],
    highlights: [
      "环境音设计出色，海浪与蝉鸣本身就是叙事的一部分。",
      "以小镇口述史的方式展开谜题，线索藏在对白里。",
      "色彩上冷暖交替，暗示回忆与现实的差别。",
    ],
    characters: [
      { name: "江野", role: "主角", desc: "暑假返乡的少年，对细节异常敏感。" },
      { name: "阿棠", role: "童年玩伴", desc: "留在小镇的女孩，知道最多却说得最少。" },
      { name: "外婆", role: "长辈", desc: "守着旧屋的人，记忆正慢慢变得模糊。" },
    ],
  },
  {
    id: "quan-yu-xinghuo",
    title: "拳与星火",
    titleJp: "拳と火花",
    category: "hot-blood",
    year: 2022,
    season: "夏",
    episodes: 24,
    status: "已完结",
    studio: "熔炉动画",
    director: "季川野",
    tags: ["热血", "竞技", "成长", "励志"],
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20determined%20young%20boxer%20raising%20a%20fist%20in%20a%20glowing%20ring%2C%20sparks%20flying%20in%20the%20air%2C%20energetic%20dynamic%20pose%2C%20warm%20red%20and%20gold%20lighting%2C%20dramatic%20contrast%2C%20simple%20dark%20background%2C%20vertical%20poster%20composition&width=600&height=800&seq=anime-cover-09&orientation=portrait",
    summary:
      "从街头到擂台，一个不被看好的拳手把每一场比赛都当成最后一战。燃，但燃得有理有据。",
    synopsis: [
      "主角是个没什么天赋的年轻拳手，起步比谁都晚。故事没有让他一夜成名，而是老老实实地拍他训练、受伤、复健，再一点点往上打。",
      "每一场比赛都安排得很有分寸：对手不是单纯的障碍，而是同样有故事的人。你会在为对手鼓掌的瞬间，也更理解主角为什么还站在台上。",
      "作品节制地使用慢镜头与特效，把煽情留给真正需要的那一刻。看完全片，你会记住的不是胜负，而是那些被打倒后重新站起来的时间。",
    ],
    highlights: [
      "拳击动作考据认真，步伐与呼吸都有讲究。",
      "用对手视角平衡叙事，避免主角单方面的爽感。",
      "结局不选择最戏剧化的写法，反而更让人信服。",
    ],
    characters: [
      { name: "罗川", role: "主角", desc: "起步晚、底子差，却从不缺席训练。" },
      { name: "老赵", role: "教练", desc: "带过很多选手，最看重的是“还愿意来”。" },
      { name: "阿KEN", role: "对手", desc: "被寄予厚望的天才，也有自己的压力。" },
    ],
  },
  {
    id: "mianbaodian-wuhou",
    title: "面包店的午后",
    titleJp: "午後のパン屋",
    category: "youth-heal",
    year: 2016,
    season: "秋",
    episodes: 12,
    status: "已完结",
    studio: "小满制作组",
    director: "田边澪",
    tags: ["治愈", "日常", "美食", "温情"],
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20small%20bakery%20in%20the%20afternoon%20with%20sunlight%20through%20the%20window%2C%20fresh%20bread%20on%20wooden%20shelves%2C%20a%20girl%20in%20apron%20arranging%20pastries%2C%20warm%20cream%20and%20honey%20palette%2C%20cozy%20healing%20atmosphere%2C%20simple%20background%2C%20vertical%20poster%20composition&width=600&height=800&seq=anime-cover-10&orientation=portrait",
    summary:
      "一家开在巷子深处的小面包店，午后阳光斜进来时，故事就开始。慢节奏，适合慢慢看。",
    synopsis: [
      "《面包店的午后》几乎没有大起大落。女主角接手了姑姑留下的小面包店，从不会揉面，到慢慢记住每位客人的口味。",
      "面粉、黄油、烤箱的温度，构成了作品最实在的细节。客人带来各自的烦恼，而女主的回应，常常只是“再等一会儿，面包就好”。",
      "它相信“等待”本身就是温柔。适合在疲惫的晚上看一集，第二天会想早点起床烤点什么。",
    ],
    highlights: [
      "烘焙过程真实可信，连发酵与整形都不省略。",
      "固定机位与长镜头营造出午后特有的安静。",
      "每集以一款面包为主题，结构清晰又治愈。",
    ],
    characters: [
      { name: "夏禾", role: "店主", desc: "从零开始学烘焙，把店当成家来经营。" },
      { name: "姑姑", role: "长辈", desc: "留下店铺与配方的人，只出现在信里。" },
      { name: "小满", role: "常客", desc: "每天下午准时来，只买同一款面包。" },
    ],
  },
];